import {combineReducers} from 'redux';

function progress(state = 'sending', action) {
  switch (action.type) {
    case 'SUBSCRIBE_REQUEST':
      return 'sending';
    case 'SUBSCRIBE_ERROR':
      return 'failure';
    case 'SUBSCRIBE_COMPLETE':
    case 'SUBSCRIBE_SUCCESS':
      return 'success';
    default:
      return state;
  }
}

function subscribed(state = 'sending', action) {
  switch (action.type) {
    case 'SUBSCRIBE_REQUEST':
      return 'sending';
    case 'SUBSCRIBE_COMPLETE':
      return action.params.subscribed;
    case 'SUBSCRIBE_ERROR':
      return action.params.subscribed;
    default:
      return state;
  }
}

export default combineReducers({
  progress,
  subscribed
});



// WEBPACK FOOTER //
// ./reducers/subscribe.js